import * as React from 'react'
import ReactDOMServer from 'react-dom/server'
import RootStyles from './InfoCard.styles'
import ErrorSvg from '../Icons/General/Error'
import Colors from '../../theme/colors'
import { toBase64 } from '../../../util/image'

export enum Variants {
  Yellow = 'Yellow',
  Purple = 'Purple',
  Pink = 'Pink',
}

type Props = {
  variant?: Variants,
  title?: string,
  icon?: React.ReactElement,
  className?: string,
  children?: React.ReactNode
}

/**
 * InfoCard element
 * @param {object} props Component props
 * @param {React.Node} props.children Content
 * @param {string} props.variant Yellow, Purple, Pink
 * @param {string} props.title Title
 * @param {React.Node} props.icon Icon next to title
 * @param {string} props.className Additional class name
 */

const getIconColor = (variant: Variants) => {
  switch (variant) {
    case Variants.Purple:
      return Colors.Secondary.purple600
    case Variants.Pink:
      return Colors.Secondary.pink700
    case Variants.Yellow:
    default:
      return Colors.Primary.yellow800
  }
}

const InfoCard: React.FunctionComponent<Props> = ({ variant = Variants.Yellow, children, icon = null, title = '', className = '' }) => {
  const classes = [className]
  classes.push(variant || Variants.Yellow)
  if (title) {
    classes.push('with-title')
  }
  let iconBase64 = ''
  if (icon) {
    iconBase64 = toBase64(<ErrorSvg color={getIconColor(variant)} />)
    classes.push('with-icon')
  }

  return (
    <RootStyles className={classes.join(' ')} icon={iconBase64}>
      {title && <h3>{title}</h3>}
      {children}
    </RootStyles>
  )
}

export default InfoCard
